import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  city: string;
  country: string;
};
const BUYERS: Buyer[] = [{
  name: 'Emily',
  city: 'London',
  country: 'United Kingdom'
}, {
  name: 'Sophie',
  city: 'Melbourne',
  country: 'Australia'
}, {
  name: 'Olivia',
  city: 'Auckland',
  country: 'New Zealand'
}, {
  name: 'Rachel',
  city: 'Vancouver',
  country: 'Canada'
}, {
  name: 'Charlotte',
  city: 'Bristol',
  country: 'United Kingdom'
}, {
  name: 'Megan',
  city: 'Wellington',
  country: 'New Zealand'
}, {
  name: 'Hannah',
  city: 'Calgary',
  country: 'Canada'
}, {
  name: 'Jessica',
  city: 'Perth',
  country: 'Australia'
}, {
  name: 'Fiona',
  city: 'Christchurch',
  country: 'New Zealand'
}, {
  name: 'Amelia',
  city: 'Sydney',
  country: 'Australia'
}, {
  name: 'Laura',
  city: 'Manchester',
  country: 'United Kingdom'
}, {
  name: 'Chloe',
  city: 'Toronto',
  country: 'Canada'
}, {
  name: 'Isla',
  city: 'Edinburgh',
  country: 'United Kingdom'
}, {
  name: 'Grace',
  city: 'Brisbane',
  country: 'Australia'
}, {
  name: 'Ruby',
  city: 'Montreal',
  country: 'Canada'
}];
const MINUTES = [2, 3, 5, 7, 8, 11, 14, 18];
export function PurchasePopup() {
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [dismissed, setDismissed] = useState<boolean>(false);
  useEffect(() => {
    if (dismissed) return;
    let hideId = 0;
    const showId = window.setInterval(() => {
      setVisible(true);
      hideId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % BUYERS.length);
      }, 5000);
    }, 9000);
    const firstId = window.setTimeout(() => setVisible(true), 3500);
    return () => {
      window.clearInterval(showId);
      window.clearTimeout(hideId);
      window.clearTimeout(firstId);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div role="status" aria-live="polite" className="animate-pop-in fixed bottom-3 left-3 z-50 max-w-[290px] rounded-2xl border-2 border-brand bg-white p-3 pr-8 shadow-xl shadow-brand/25 sm:max-w-[320px]" data-id="element-186" data-mp="2ap32fekxwyda">
      <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-1.5 top-1.5 rounded-full p-1 text-softgray transition hover:bg-ivory hover:text-charcoal" data-id="element-187" data-mp="2ko276m2l49v0">
        <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-188" data-mp="1wwwu2eo13voe" />
      </button>

      <div className="flex items-start gap-2.5" data-id="element-189" data-mp="1wutvh68t8u82">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sage/15" data-id="element-190" data-mp="21v85uuxvwg99">
          <CheckCircle2Icon className="h-5 w-5 text-sage" aria-hidden="true" data-id="element-191" data-mp="26nrj1qsnt9dj" />
        </span>
        <div data-id="element-192" data-mp="196j2sqd9q0uv">
          <p className="font-head text-[13px] font-bold leading-tight text-charcoal" data-id="element-193" data-mp="1972kc5z0an8d">
            {buyer.name} from {buyer.city}, {buyer.country}
          </p>
          <p className="text-[12px] leading-snug text-softgray" data-id="element-194" data-mp="3rhglp8qxq919">
            just purchased <span className="font-semibold text-brand" data-id="element-195" data-mp="3nfd5y7x8gia6">Yoga Teaching Vault™</span>
          </p>
          <p className="mt-0.5 text-[11px] text-softgray" data-id="element-196" data-mp="3iga0wnh96c27">{minutes} minutes ago · Verified</p>
        </div>
      </div>
    </div>;
}